@if (parentGallery && subGalleries) {
  <div class="gallery-tree">
    <a
      class="gallery parent-gallery"
      [routerLink]="links[parentGallery.id]"
      [class.active]="gallery.id === parentGallery.id"
    >
      <div class="active-indicator"></div>
      @if (parentGallery.teaser.uuid) {
        <img
          [src]="parentGallery | galleryTeaserUrl: 56"
          [style.object-position]="
            parentGallery.teaser.uuid === parentGallery.cover.uuid ? parentGallery.cover.position : undefined
          "
          alt=""
          class="gallery-teaser-asset"
        />
      }
      @if (!parentGallery.teaser.uuid) {
        <div class="gallery-teaser-asset">
          <app-svg src="/assets/icons/gallery-folder.svg"></app-svg>
        </div>
      }
      <div class="gallery-meta">
        <b appTooltip="{{ parentGallery.name || parentGallery.title || 'Untitled' }}">{{
          parentGallery.name || parentGallery.title || 'Untitled'
        }}</b>
        <span class="sub">
          @if (parentGallery.enabled_gallery_statuses.length > 1) {
            <app-svg
              src="/assets/icons/16/{{ parentGallery.status | galleryStatusIcon }}.svg"
              size="-1"
              [attr.color]="parentGallery.status | galleryStatusColor"
            ></app-svg>
          }
          <span>Main Gallery ⋅ {{ parentGallery.assets_count }} Assets</span>
        </span>
      </div>
      <button
        appButton
        name="gallery-info"
        data-test-id="gallery-info"
        location="gallery-tree"
        (click)="openGalleryInfo(parentGallery, $event); onClose.emit()"
        [iconButton]="true"
        shape="round"
        color="gray-bordered"
      >
        <app-svg src="/assets/icons/info-outline.svg"></app-svg>
      </button>
    </a>
    <!-- <button (click)="openGalleryInfo(parentGallery)"></button> -->
    <div class="galleries-container">
      <div class="sub-galleries">
        @for (subGallery of subGalleries; track subGallery; let i = $index) {
          <a
            [routerLink]="links[subGallery.id]"
            class="gallery sub-gallery"
            [class.active]="gallery.id === subGallery.id"
          >
            <div class="active-indicator"></div>
            @if (subGallery.teaser.uuid) {
              <img
                [src]="subGallery | galleryTeaserUrl: 56"
                [style.object-position]="
                  subGallery.teaser.uuid === subGallery.cover.uuid ? subGallery.cover.position : undefined
                "
                alt=""
                class="gallery-teaser-asset"
              />
            }
            @if (!subGallery.teaser.uuid) {
              <div class="gallery-teaser-asset">
                <app-svg src="/assets/icons/gallery-folder.svg"></app-svg>
              </div>
            }
            <div class="gallery-meta">
              <b appTooltip="{{ subGallery.name || subGallery.title || 'Untitled' }}">{{
                subGallery.name || subGallery.title || 'Untitled'
              }}</b>
              <span class="sub">
                @if (subGallery.enabled_gallery_statuses.length > 1) {
                  <app-svg
                    src="/assets/icons/16/{{ subGallery.status | galleryStatusIcon }}.svg"
                    size="-1"
                    [attr.color]="subGallery.status | galleryStatusColor"
                  ></app-svg>
                }
                <span>Sub Gallery ⋅ {{ subGallery.assets_count }} Assets</span>
              </span>
            </div>
            <button
              appButton
              name="gallery-info"
              location="gallery-tree"
              (click)="openGalleryInfo(subGallery, $event); onClose.emit()"
              [iconButton]="true"
              shape="round"
              color="gray-bordered"
            >
              <app-svg src="/assets/icons/info-outline.svg"></app-svg>
            </button>
          </a>
        }
      </div>
      @if (accessLevel === 'edit') {
        <div class="create-new-gallery">
          <button
            appButton
            name="new-gallery"
            location="gallery-tree"
            [hasIcon]="true"
            color="gray-bordered"
            shape="round"
            (click)="addSubGallery($event)"
          >
            <app-svg src="/assets/icons/plus-outline.svg"></app-svg>
            @if (!loading) {
              <div class="create-sub-gallery">
                Create Sub Gallery
                <app-upgrade-badge
                  location="gallery-tree"
                  scope="gallery:sub-gallery"
                  [tenantId]="gallery.tenant?.['id'] || gallery.tenant"
                >
                </app-upgrade-badge>
              </div>
            }
            @if (loading) {
              <span>Creating...</span>
            }
          </button>
        </div>
      }
    </div>
  </div>
}
@if (noAccess) {
  <div class="no-access">No access</div>
}
@if (!parentGallery && !subGalleries && !noAccess) {
  <div class="loading">
    <app-loading-indicator size="small"></app-loading-indicator>
  </div>
}
